export default async function fetchRules({ commit, rootGetters, dispatch }) {
    try {
        commit('SET_FETCH_RULES_LOADING', true);

        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

        let customer_id = customer.customer_id;
        if (customer_id === 0) {
            customer_id = selected_customer.customer_id;
        }

        const url = `/proxy/ai/document-analysis/classifications?customer_id=${customer_id}`;
        const response = await window.axios.get(url);

        if (response.data.success) {
            const rules = response.data.data?.documentClassifications || [];
            commit('SET_RULES', rules);
        } else {
            dispatch('notifications/setError', 'Failed to fetch classification rules', { root: true });
        }
    } catch (error) {
        console.error('Error fetching classification rules:', error);
        dispatch('notifications/setError', 'Failed to fetch classification rules', { root: true });
    } finally {
        commit('SET_FETCH_RULES_LOADING', false);
    }
}